import { useContext, useEffect } from "react";
import { Alert, Spinner, Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import TooltipTitle from "./../../../utils/TooltipTitle/TooltipTitle";
import OnTypeSearch from "./../../../utils/OnTypeSearch/OnTypeSearch";
import ExportCSV from "../../../utils/ExportCSV/ExportCSV";
import { ConvertCurrency } from "../../../utils/Currency/Currency";
import { employerAdminContext } from "../../../context/Admin/EmployerAdminContext/EmployerAdminContext";
import { convertDataToCSV } from "../../../utils";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const EmployerAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    users,
    setUsers,
    employer,
    employers,
    id,
    name,
    setName,
    employees,
    primaryCharge,
    setPrimaryCharge,
    code,
    setCode,
    post,
    setPost,
    user,
    setUser,
    userSearch,
    setUserSearch,
    search,
    setSearch,
    pageNumber,
    setPageNumber,
    totalCount,
    limit,
    setLimit,
    isShowModal,
    isShowPersonnelModal,
    isShowEmployeeModal,
    isUserLoading,
    handleShowEmployeeModal,
    handleCloseEmployeeModal,
    handleShowModal,
    handleCloseModal,
    handleClosePersonnelModal,
    handleGetEmployerList,
    handleGetEmployeeList,
    handleCreateEmployer,
    handleEditEmployer,
    handleDeleteEmployer,
    handleAddEmployee,
    handleRemoveEmployee,
    handleGetEmployees,
    handleDeleteEmployee,
    handleCreateEmployee,
    handleEditEmployee,
    handleGetUsers,
    handleResetState,
  } = useContext(employerAdminContext);

  // Set State After Typing
  const onTypeUserSearch = OnTypeSearch(setUserSearch);
  useEffect(() => {
    if (isShowEmployeeModal && userSearch) handleGetUsers();
    else setUsers([]);
  }, [userSearch]);

  useEffect(() => {
    handleGetEmployerList();
  }, []);

  useEffect(() => {
    if (!isEmpty(employer)) handleGetEmployees(employer);
  }, [pageNumber, limit]);

  const otherCalculate = (_items) => {
    if (!_items) return 0;

    return (
      _items.all -
      (_items.cleaning +
        _items.moving +
        _items.carwash +
        _items.appliance +
        _items.dc +
        _items.ac +
        _items.carpet)
    );
  };

  return (
    <>
      <SiteTitle title="سازمان ها" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "سازمان ها", type: "a" },
        ]}
        title="خدمات سازمانی"
      />

      <CardLayout>
        {permission.employer_create_update && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(employers) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>شناسه</th>
                <th>نام</th>
                <th>کد سازمان</th>
                <th>شارژ اولیه</th>
                <th>تعداد کارکنان</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {employers.map((_item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{_item.id}</td>
                  <td>{_item.name}</td>
                  <td>{_item.organization_code}</td>
                  <td>
                    <ConvertCurrency price={_item.primary_charge} />
                  </td>
                  <td>{_item.total}</td>
                  <td className="mw-25">
                    {permission.employee_list && (
                      <button
                        onClick={() => handleGetEmployeeList(_item)}
                        className="btn btn-warning mr-2"
                      >
                        پرسنل
                      </button>
                    )}
                    {permission.employee_list && (
                      <button
                        onClick={() => handleGetEmployees(_item)}
                        className="btn btn-info mr-2"
                      >
                        کارمندان
                      </button>
                    )}
                    {permission.employer_create_update && (
                      <button
                        onClick={() => handleShowModal(_item)}
                        className="btn btn-primary mr-2"
                      >
                        ویرایش
                      </button>
                    )}
                    {permission.employer_delete && (
                      <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteEmployer(_item.organization_code),
                            `آیا از حذف ${_item.name} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} سازمان`}
        show={isShowModal}
        onHide={handleCloseModal}
        size="lg"
      >
        <div className="row">
          <div className="col-12 col-md-6 mb-2">
            <label htmlFor="name">نام</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col-6 mb-2">
            <label htmlFor="code">کد سازمان</label>
            <input
              type="number"
              id="code"
              name="code"
              className="form-control"
              min={0}
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className="col-6 mb-2">
            <label htmlFor="code">شارژ اولیه</label>
            <input
              type="number"
              id="primaryCharge"
              name="primaryCharge"
              className="form-control"
              min={0}
              value={primaryCharge}
              onChange={(e) => setPrimaryCharge(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <form
              autoComplete="off"
              onSubmit={handleAddEmployee}
              className="row align-items-end"
            >
              <div className="col-4">
                <label htmlFor="employeeCode">کد پرسنلی</label>
                <input
                  type="text"
                  id="employeeCode"
                  name="employeeCode"
                  className="form-control"
                />
              </div>
              <div className="col-4">
                <label htmlFor="employeePost">سمت پرسنل</label>
                <input
                  type="text"
                  id="employeePost"
                  name="employeePost"
                  className="form-control"
                />
              </div>
              <div className="col-4">
                <button className="btn btn-success btn-block" type="submit">
                  افزودن
                </button>
              </div>
            </form>
          </div>
          {!isEmpty(employees) && (
            <div className="col-12">
              {employees?.map((_item) => (
                <p key={_item.code} className="alert alert-info">
                  {_item.post} با کد پرسنلی {_item.code}
                  <i
                    className="fa fa-trash text-danger float-right"
                    type="button"
                    onClick={() => handleRemoveEmployee(_item.code)}
                  />
                </p>
              ))}
            </div>
          )}
        </div>
        <button
          className="btn btn-primary btn-block"
          onClick={id ? handleEditEmployer : handleCreateEmployer}
        >
          <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
        </button>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Personnel Modal */}
      <CustomModal
        title="پرسنل"
        show={isShowPersonnelModal}
        onHide={handleClosePersonnelModal}
        size="xl"
      >
        <ExportCSV
          csvData={() =>
            convertDataToCSV(employees, "employees", otherCalculate)
          }
        />
        <Table hover borderless responsive striped className="mt-2">
          <thead className="thead-dark text-center">
            <tr>
              <th>#</th>
              <th>سمت</th>
              <th>کد اختصاصی</th>
              <th>ورود سازمانی</th>
              <th>نام</th>
              <th>نام خانوادگی</th>
              <th>شماره موبایل</th>
              <th>کل</th>
              <th>نظافت</th>
              <th>اسباب کشی</th>
              <th>کارواش</th>
              <th>لوازم خانگی</th>
              <th>خشکشویی</th>
              <th>کولرگازی</th>
              <th>قالیشویی</th>
              <th>سایر</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {employees.map((_item, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{_item?.post}</td>
                <td>{_item?.employee_code}</td>
                {!isEmpty(_item?.user) ? (
                  <>
                    <td>
                      <i className="fa fa-check text-success" />
                    </td>
                    <td>{_item?.user?.first_name}</td>
                    <td>{_item?.user?.last_name}</td>
                    <td>{_item?.user?.mobile}</td>
                    <td>{_item?.user?.order_count?.all}</td>
                    <td>{_item?.user?.order_count?.cleaning}</td>
                    <td>{_item?.user?.order_count?.moving}</td>
                    <td>{_item?.user?.order_count?.carwash}</td>
                    <td>{_item?.user?.order_count?.appliance}</td>
                    <td>{_item?.user?.order_count?.dc}</td>
                    <td>{_item?.user?.order_count?.ac}</td>
                    <td>{_item?.user?.order_count?.carpet}</td>
                    <td>{otherCalculate(_item?.user?.order_count)}</td>
                  </>
                ) : (
                  <>
                    <td>
                      <i className="fa fa-times text-danger" />
                    </td>
                    {[...Array(12)].map((_, index) => (
                      <td key={index}>-</td>
                    ))}
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </CustomModal>
      {/* End Personnel Modal */}

      {/* Start Employee Modal */}
      <CustomModal
        title="کارمندان"
        show={!isEmpty(employer)}
        onHide={handleResetState}
        size="xl"
      >
        <button
          className="btn btn-success mb-3"
          onClick={() => handleShowEmployeeModal()}
        >
          افزودن
        </button>
        <form
          className="input-group mb-3"
          onSubmit={(e) => {
            e.preventDefault();
            handleGetEmployees(employer);
          }}
        >
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        {isEmpty(employees) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table hover borderless responsive striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>سمت</th>
                  <th>کد اختصاصی</th>
                  <th>ورود سازمانی</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>شماره موبایل</th>
                  <th />
                </tr>
              </thead>
              <tbody className="text-center">
                {employees.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item?.post}</td>
                    <td>{_item?.employee_code}</td>
                    {!isEmpty(_item?.user) ? (
                      <>
                        <td>
                          <i className="fa fa-check text-success" />
                        </td>
                        <td>{_item?.user?.first_name}</td>
                        <td>{_item?.user?.last_name}</td>
                        <td>{_item?.user?.mobile}</td>
                      </>
                    ) : (
                      <>
                        <td>
                          <i className="fa fa-times text-danger" />
                        </td>
                        {[...Array(3)].map((_, index) => (
                          <td key={index}>-</td>
                        ))}
                      </>
                    )}
                    <th>
                      <button
                        onClick={() => handleShowEmployeeModal(_item)}
                        className="btn btn-primary mr-2"
                      >
                        ویرایش
                      </button>
                      {/* <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteEmployee(_item.id),
                            `آیا از حذف ${_item.post} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      /> */}
                    </th>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CustomModal>
      {/* End Personnel Modal */}

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} کارمند`}
        show={isShowEmployeeModal}
        onHide={handleCloseEmployeeModal}
      >
        <div className="row">
          <div className="col-12 col-md-6 mb-2">
            <label htmlFor="user">کاربر</label>
            {/* Start Select User */}
            <form
              className="input-group position-relative mb-2"
              onSubmit={(e) => {
                handleGetUsers(e);
              }}
            >
              <input
                {...onTypeUserSearch}
                id="userSearch"
                name="userSearch"
                placeholder="جستجو کاربر"
                className="form-control"
                autocomplete="off"
              />
              <div className="input-group-append">
                <button className="btn btn-primary" type="submit">
                  <i className="fa fa-search"></i>
                </button>
              </div>
              <div className="input-group-append">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setTimeout(() => setUsers([]), 300);
                    setUserSearch("");
                  }}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
            </form>
            {!isEmpty(user) && (
              <Alert color="primary">
                <div className="p-2 d-flex justify-content-between">
                  <div>
                    {user?.first_name} {user?.last_name}
                  </div>
                  -{" "}
                  <TooltipTitle title="شماره موبایل">
                    <span>{user?.mobile}</span>
                  </TooltipTitle>{" "}
                  -{" "}
                  <TooltipTitle title="شناسه">
                    <span>{user?.pk}</span>
                  </TooltipTitle>
                </div>
              </Alert>
            )}

            {isUserLoading ? (
              <div className="text-center mt-2">
                <Spinner animation="grow" variant="success" />
              </div>
            ) : isEmpty(users) ? null : (
              <div className="position-relative">
                <div className="searchListAutoComplete">
                  {users.map((_user) => (
                    <div className="d-flex align-items-center">
                      <div
                        className="card border m-0 searchAutoCompleteCard col font-weight-bold"
                        onClick={() => {
                          setUser(_user);
                          setUsers([]);
                        }}
                      >
                        <div className="p-2 d-flex justify-content-between">
                          <div>
                            {_user?.first_name} {_user?.last_name}
                          </div>
                          <div className="bg-white">
                            <TooltipTitle title="شماره موبایل">
                              <span>{_user?.mobile}</span>
                            </TooltipTitle>{" "}
                            -{" "}
                            <TooltipTitle title="شناسه">
                              <span>{_user?.pk}</span>
                            </TooltipTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label htmlFor="code">کد کارمند</label>
            <input
              type="text"
              id="code"
              name="code"
              className="form-control"
              min={0}
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label htmlFor="post">سمت</label>
            <input
              type="text"
              id="post"
              name="post"
              className="form-control"
              value={post}
              onChange={(e) => setPost(e.target.value)}
            />
          </div>
        </div>
        <button
          className="btn btn-primary btn-block"
          onClick={id ? handleEditEmployee : handleCreateEmployee}
        >
          <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
        </button>
      </CustomModal>
      {/* End Create Modal */}
    </>
  );
};

export default EmployerAdmin;
